import { __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames, MakeEgdsSizingLength } from 'uitk-react-utils';
import styles from './uitk-sheet.css';
import { setFocusableElems, setElementFocus, hasSheetClassName, setFocus, defineSheetLayout, trapUpperBoundFocus, trapLowerBoundFocus } from './uitk-sheet-utilities.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkCenteredSheet = function (props) {
    var _a;
    var ariaLabel = props.ariaLabel, _b = props.autoFocus, autoFocus = _b === void 0 ? true : _b, children = props.children, className = props.className, isVisible = props.isVisible, _c = props.centeredSheetSize, centeredSheetSize = _c === void 0 ? 'medium' : _c, height = props.height, _d = props.returnFocusOnClose, returnFocusOnClose = _d === void 0 ? true : _d, triggerRef = props.triggerRef, _e = props.type, type = _e === void 0 ? 'centered' : _e;
    var sheetRef = React.useRef(null);
    var baseClassName = "uitk-".concat(type, "-sheet");
    var sheetClassNames = getClassNameList(baseClassName, className, centeredSheetSize === 'small' ? "uitk-centered-sheet-small" : 'uitk-centered-sheet-medium');
    var sheetStyles = __assign({}, (height && (_a = {},
        _a["--uitk-centered-sheet-height"] = "".concat(MakeEgdsSizingLength(height)),
        _a)));
    // Hooks
    React.useEffect(function () {
        setFocusableElems(sheetRef);
    }, []);
    // Set focus when initial mount only
    React.useEffect(function () {
        if (autoFocus && isVisible) {
            setElementFocus(sheetRef, true, true);
        }
        isVisible && hasSheetClassName('add');
    }, [autoFocus, isVisible]);
    // "unmount" hook
    React.useEffect(function () { return function () {
        if (returnFocusOnClose) {
            setFocus(triggerRef);
        }
        hasSheetClassName('remove');
    }; }, [returnFocusOnClose, triggerRef]);
    var trapUpperFocus = function () {
        setFocusableElems(sheetRef);
        trapUpperBoundFocus();
    };
    var trapLowerFocus = function () {
        setFocusableElems(sheetRef);
        trapLowerBoundFocus();
    };
    var _f = defineSheetLayout(children), hasCloseButton = _f.hasCloseButton, layoutProps = _f.layoutProps, closeButtonLayoutProps = _f.closeButtonLayoutProps, closeButtonElem = _f.closeButtonElem, childrenElem = _f.childrenElem;
    return (React.createElement("section", { ref: sheetRef, className: sheetClassNames, tabIndex: -1, role: "dialog", "aria-modal": true, "aria-label": ariaLabel, style: sheetStyles },
        React.createElement("div", { tabIndex: 0, onFocus: trapUpperFocus, "aria-hidden": "true" }),
        hasCloseButton && (React.createElement(UitkLayoutFlex, __assign({}, layoutProps),
            React.createElement(UitkLayoutFlexItem, __assign({}, closeButtonLayoutProps),
                React.createElement("div", null, closeButtonElem)),
            childrenElem && React.createElement(UitkLayoutFlexItem, null, childrenElem))),
        !hasCloseButton && childrenElem,
        React.createElement("div", { tabIndex: 0, onFocus: trapLowerFocus, "aria-hidden": "true" })));
};
UitkCenteredSheet.displayName = 'UitkCenteredSheet';

export { UitkCenteredSheet };
